function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "product_bed-runner");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.777 5.777v-1.277h-11.5v1.277h-16.611v20.445h16.611v1.277h11.5v-1.277h2.556v-20.445zM17.277 24.944h-15.333v-17.888h15.333zM30.056 24.944h-1.278v-12.777c-0.767 0-1.277 0.511-1.277 1.277v12.778h-8.944v-20.445h8.944v3.833c0 0.767 0.511 1.278 1.277 1.278v-3.833h1.278z"
});

var SvgProductBedRunner = function SvgProductBedRunner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductBedRunner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_bed-runner.1274798c.svg";
export { ForwardRef as ReactComponent };